import * as React from 'react';
import { Link } from 'react-router-dom';
import { LogoCentered } from '../../Images';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './Activation.messages';

import './ActivationSucceeded.scss';

export interface ActivationSucceededProps {
}

export class ActivationSucceeded extends React.Component<ActivationSucceededProps> {
  public render() {
    return (
      <div className="partial-activation-succeeded d-flex justify-content-center align-items-center h-100">
        <div className="inner w-100 pt-5 pb-5">
          <div className="col-12">
            <LogoCentered />
            <p>
              <FormattedMessage {...MESSAGES.activationSucceededText} />
            </p>
            <Link className="btn btn-secondary w-100 d-block mt-4" to="/">
              <FormattedMessage {...MESSAGES.activationSucceededButton} />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
